import InputMask from './InputMask';
import ControlledComponent from '../../../utils/ControlledComponent';

export const ControlledInputMask = ControlledComponent(InputMask);

export default InputMask;
